module.exports = __webpack_public_path__ + "img/P150T_weapon_117.f53d7ffa.png";